<!--
   The MIT License

   Copyright (c) 2019- Nordic Institute for Interoperability Solutions (NIIS)
   Copyright (c) 2018 Estonian Information System Authority (RIA),
   Nordic Institute for Interoperability Solutions (NIIS), Population Register Centre (VRK)
   Copyright (c) 2015-2017 Estonian Information System Authority (RIA), Population Register Centre (VRK)

   Permission is hereby granted, free of charge, to any person obtaining a copy
   of this software and associated documentation files (the "Software"), to deal
   in the Software without restriction, including without limitation the rights
   to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   copies of the Software, and to permit persons to whom the Software is
   furnished to do so, subject to the following conditions:

   The above copyright notice and this permission notice shall be included in
   all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
   THE SOFTWARE.
 -->
<template>
  <g>
    <path
      d="M17.1929 7.06417C17.1929 9.80764 14.9689 12.0317 12.2254 12.0317C9.48196 12.0317 7.25794 9.80764 7.25794 7.06417C7.25794 4.3207 9.48196 2.09668 12.2254 2.09668C14.9689 2.09668 17.1929 4.3207 17.1929 7.06417Z"
      fill="#211E1E"
    />
    <path
      d="M13.1286 21.0637H5C4.99972 19.9608 5.25192 18.8725 5.73726 17.8822C6.22261 16.8918 6.92823 16.0257 7.80005 15.3502C8.67188 14.6747 9.68676 14.2078 10.7669 13.9852C11.5458 13.8246 12.3437 13.7942 13.1286 13.8931V21.0637Z"
      fill="#211E1E"
    />
    <path
      d="M17.2704 17.4507L15.3545 15.5347L16.6318 14.2575L18.5477 16.1734L20.4636 14.2575L21.7409 15.5347L19.825 17.4507L21.7409 19.3666L20.4636 20.6439L18.5477 18.728L16.6318 20.6439L15.3545 19.3666L17.2704 17.4507Z"
      fill="#211E1E"
    />
    <path
      d="M17.2704 17.4505L15.3545 15.5346L16.6318 14.2573L18.5477 16.1733L20.4636 14.2573L21.7409 15.5346L19.825 17.4505L21.7409 19.3665L20.4636 20.6438L18.5477 18.7278L16.6318 20.6438L15.3545 19.3665L17.2704 17.4505Z"
      fill="#EC4040"
    />
  </g>
</template>
